import moment from 'moment';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { downloadFile } from 'actions/common';

export const GET_RTK_XLS_REQUEST = 'GET_RTK_XLS_REQUEST';
export const GET_RTK_XLS_ALL_SUCCESS = 'GET_RTK_XLS_ALL_SUCCESS';
export const GET_RTK_XLS_FAILURE = 'GET_RTK_XLS_FAILURE';

function requestRtkXls() {
  return {
    type: GET_RTK_XLS_REQUEST,
    isGettingRtkXls: true
  };
}

function receiveRtkXls(data) {
  return {
    type: GET_RTK_XLS_ALL_SUCCESS,
    userRtks: data,
    isGettingRtkXls: false
  };
}

function rejectRtkXls() {
  return {
    type: GET_RTK_XLS_FAILURE,
    isGettingRtkXls: false
  };
}

export function getRtkXls() {
  return (dispatch) => {
    dispatch(requestRtkXls());
    const promise = () => ApiService
      .getRtkXls()
      .then((response) => {
        dispatch(receiveRtkXls(response.data));
        return dispatch(
          downloadFile(
            response.data,
            `${ moment().format('DD_MMM_YYYY') }_rtk_report.xlsx`,
            'application/vnd.ms-excel'
          )
        );
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          if (error.response) {
            error.response.data = { code: error.response.status, message: 'Sorry, we were unable to generate your excel report at this time, please come back later' };
          }
          dispatch(handleException(error, rejectRtkXls, true));
        }
      });
    return promise();
  };
}
